<ng-template #settingsModal let-modal>
    <div class="modal-header border-bottom p-3">
      <h6 id="offcanvasAddUserLabel" class="offcanvas-title">
        {{ "Settings" | translate }}
      </h6>
      <button
        type="button"
        class="btn-close close-modal-button text-reset"
        (click)="modal.dismiss('Cross click')"
        aria-label="Close"
      ></button>
    </div>
    <div class="modal-body mx-0 flex-grow-0">
      <div class="row modal-body-form" *ngIf="fields!=null">
        <div class="col-12">
          <h6>{{ "ChooseTableColumnsText" | translate }}</h6>
        </div>
        <div class="col-6" *ngFor="let item of fields; let i = index">
          <div
            class="form-check custom-option custom-option-basic"
            [ngClass]="{ checked: item.isVisibleInTable }"
          >
            <label
              class="form-check-label custom-option-content"
              [for]="'tableCustomize' + i"
            >
              <input
                class="form-check-input"
                type="checkbox"
                [id]="'tableCustomize' + i"
                [(ngModel)]="item.isVisibleInTable"
              />
              <span class="custom-option-header">
                <span class="h6 mb-0">{{ item.label | translate }}</span>
              </span>
            </label>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer border-top p-3">
      <button type="submit" class="btn btn-primary me-sm-3 me-1 data-submit"
      (click)="SubmitSetting()">
        {{ "Submit" | translate }}
      </button>
      <button
        type="reset"
        class="btn btn-label-secondary"
        (click)="modal.dismiss('Cross click')"
      >
        {{ "Cancel" | translate }}
      </button>
    </div>

  
